module.exports = __webpack_public_path__ + "static/media/icon-condo.e11d7696.svg";